
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Get } from 'vuex-pathify';

import { FulfillmentType } from '../../../types/ProductDelivery';

import FulfillmentOptionDisclaimer from './FulfillmentOptionDisclaimer.vue';
import FulfillmentOptionLink from './FulfillmentOptionLink.vue';
import Icon from 'Src/js/components/Icon.vue';
import StockSubscriptionForm from './StockSubscriptionForm.vue';
import StockSubscriptionFormTrigger from './StockSubscriptionFormTrigger.vue';
import TransitionExpand from 'Src/js/components/transitions/TransitionExpand.vue';

@Component({
	name: 'FulfillmentOption',
	components: {
		Icon,
		TransitionExpand,
		FulfillmentOptionLink,
		FulfillmentOptionDisclaimer,
		StockSubscriptionForm,
		StockSubscriptionFormTrigger,
	}
})
export default class FulfillmentOption extends Vue {

	@Get('customerEmail')
	readonly customerEmail: string | null;

	@Prop({ type: Boolean })
	readonly disabled: boolean;

	@Prop({ type: String })
	readonly label: string;

	@Prop({ type: Boolean })
	readonly loading: boolean;

	@Prop({ type: String })
	readonly promoText: string;

	@Prop({ type: Boolean, required: true })
	readonly selected: boolean;

	@Prop({ type: String, required: true })
	readonly fulfillmentOption: FulfillmentType;

	@Prop({ type: String, required: true })
	readonly listClass: string;

	@Prop({ type: String, required: true })
	readonly blainNumber: string;

	@Prop({ type: String, default: null })
	readonly disclaimer: string | null;

	@Prop({ type: Boolean })
	readonly stockSubscriptionFormEnabled: boolean;

	get ariaLabel(): string {
		return `Change delivery method to ${this.listClass}`;
	}

	get fulfillmentRadioName(): string {
		return `fulfillment-${this.blainNumber}`;
	}
	
	get fulfillmentRadioId(): string {
		return `${this.fulfillmentOption}-${this.blainNumber}`;
	}

	showStockSubscriptionForm: boolean = false;

	toggleStockSubscriptionForm() {
		this.showStockSubscriptionForm = !this.showStockSubscriptionForm;
	}

	changeOption() {
		if (this.selected || this.disabled || this.loading) return;
		this.$emit('change', this.fulfillmentOption);
	}
}
